import { Component, EventEmitter, Output } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ACTION_STATUS, ActionBarDetailHandlerModel, ActionbarDetailService } from "src/app/shared/ui/actionbar-detail";
import { ActionButtonModel, CustomButtonModel, DeleteButtonModel, EditButtonModel } from "src/app/shared/ui/actionbar-detail/models";

@Component({
    selector: 'op-order-detail-individual-document-actionbar',
    templateUrl: 'order-detail-individual-document-actionbar.component.html',
    providers: [
        ActionbarDetailService
    ]
})
export class OrderDetailIndividualDocumentActionbarComponent {
    private unsubscribe$ = new Subject();
    private actionButton = new ActionButtonModel();
    private editButton = new EditButtonModel();
    private deleteButton = new DeleteButtonModel();
    public printAndSend = new CustomButtonModel('Print and Send',
        ACTION_STATUS.print,
        'description',
        'color-info-500')
    private action: boolean = false;

    @Output() edit = new EventEmitter();
    @Output() delete = new EventEmitter();

    constructor(private actionbarDetailService: ActionbarDetailService) {
        this.printAndSend.disable();
    }

    ngAfterViewInit(): void {
        this.hideActionBarButton();
        this.actionbarDetailService.action$.pipe(takeUntil(this.unsubscribe$)).subscribe(
            actionId => {
                this.actionbarClick(actionId);
            }
        )

        this.actionButton.show();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private hideActionBarButton() {
        this.editButton.hide();
        this.deleteButton.hide();
        this.printAndSend.hide();
        this.updateStateBtn();
    }

    private showActionBarButton() {
        this.editButton.show();
        this.deleteButton.show();
        this.printAndSend.show();
        this.updateStateBtn();
    }

    private updateStateBtn() {
        let actionbarDefaultState = new ActionBarDetailHandlerModel(
            this.actionButton,
            this.editButton,
            this.deleteButton,
            this.printAndSend
        );
        this.actionbarDetailService.updateState(actionbarDefaultState);
    }

    private actionbarClick(clickedBtn) {
        switch (clickedBtn) {
            case ACTION_STATUS.action:
                this.action = !this.action;
                if (this.action) {
                    this.showActionBarButton();
                    break;
                }
                this.hideActionBarButton();
                break;
            case ACTION_STATUS.edit:
                this.edit.emit();
                break;
            case ACTION_STATUS.delete:
                this.delete.emit();
                break;
            default:
                break;
        }
    }
    public disableActionButton(value: boolean) {
        this.actionButton.disable(value);
    }
}